import UserModel from "./UserModel";

export default class UserSettingsModel {
    constructor(data?: any) {
        if (data) {
            if (data.user?.id) {
                this.user = new UserModel(data.user);
            }
            
            this.leftMenuCollapse = (data.leftMenuCollapse === null ? false : data.leftMenuCollapse);
        }
    }

    user: UserModel | null = null;    
    leftMenuCollapse = false;
}